import {MissingDriverError} from "../error/MissingDriverError";
import {SqliteDriver} from "./sqlite/SqliteDriver";
import {CordovaDriver} from "./cordova/CordovaDriver";
import {SqljsDriver} from "./sqljs/SqljsDriver";
import {Driver} from "./Driver";
import {Connection} from "../connection/Connection";
import { WebsqlDriver } from "./websql/WebsqlDriver";

/**
 * Helps to create drivers.
 */
export class DriverFactory {

    /**
     * Creates a new driver depend on a given connection's driver type.
     */
    create(connection: Connection): Driver  {
        const {type} = connection.options;
        switch (type) {
            case "sqlite":
                return new SqliteDriver(connection);
            case "cordova":
                return new CordovaDriver(connection);
            case "sqljs":
                return new SqljsDriver(connection);
            case "websql":
                return new WebsqlDriver(connection);
            default:
                throw new MissingDriverError(type);
        }
    }

}
